/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Divider, useMantineTheme } from '@mantine/core';

import ProductNavbarContainer from './product-basic-navbar';

export function NavbarContents({
  teamId,
  teams,
  isTeamOwner,
}: {
  teamId: string;
  teams: {
    id: string;
    name: string | null;
  }[];
  isTeamOwner: boolean;
}) {
  const theme = useMantineTheme();

  return (
    <ProductNavbarContainer>
      <ProductNavbarContainer.CurrentTeamProfileSection teamId={teamId} />
      <Divider color={theme.pf.color.border.neutral.default} my={theme.pf.layout['3xs']} />
      {isTeamOwner && (
        <>
          <ProductNavbarContainer.TeamMenuSection teamId={teamId} />
          <Divider color={theme.pf.color.border.neutral.default} my={theme.pf.layout['3xs']} />
        </>
      )}

      {teams.length > 0 && (
        <>
          <ProductNavbarContainer.SwitchableTeamsSection teams={teams} />
          <ProductNavbarContainer.AllTeamsLink />
          <Divider color={theme.pf.color.border.neutral.default} my={theme.pf.layout['3xs']} />
        </>
      )}
      <ProductNavbarContainer.ProductsSection teamId={teamId} />
      <Divider color={theme.pf.color.border.neutral.default} my={theme.pf.layout['3xs']} />
      <ProductNavbarContainer.AllProductsLink teamId={teamId} />
    </ProductNavbarContainer>
  );
}
